<template>
  <v-btn
    @click="$emit('click', color)"
    :class="{
      'v-btn--active': isActive,
    }"
  >
    <v-row align="center" class="flex-column" justify="center">
      <v-icon class="cols 12">
        format_color_text
      </v-icon>

      <v-sheet
        tile
        style="margin-top: -4px;"
        height="4"
        width="26"
        :color="color"
      ></v-sheet>
    </v-row>
  </v-btn>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true,
      default: "#F44336",
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>
